<div class="full-height layout-column">

  <div class="layout-row layout-align-start-center padding-5 margin-top-5">
    <bringoz-icon iconName="location-pin-outline"></bringoz-icon>
    <span *ngIf="packageList.length" class="br-body-2">{{packageList[0].dropoffAddress | bringozAddress}}</span>
  </div>

  <div class="layout-column padding-5">
    <div class="layout-row layout-align-start-center">
      <span class="br-body-2">{{'Packing status' | translate}}</span>:
      <span class="br-body-2 margin-left-5">{{'packingInfoStatus.' + packingDisplayStatus | translate}}</span>
    </div>

    <div *ngIf="packingDisplayStatus === packingInfoStatusType.InProcess"
         class="br-body-2 layout-row layout-align-start-center">
      <span>{{'Started at' | translate}}</span>:
      <span class="margin-left-5">
        {{packingInfo.packingStartedAt | date: "MM/dd/yyyy"}}  {{packingInfo.packingStartedAt | date: 'HH:mm'}}
      </span>
    </div>

    <div *ngIf="packingDisplayStatus === packingInfoStatusType.Packed"
         class="br-body-2 layout-row layout-align-start-center">
      <span>{{'Packed at' | translate}}</span>:
      <span *ngIf="packingInfo?.packedDate" class="margin-left-5">
        {{packingInfo.packedDate | date: "MM/dd/yyyy"}}  {{packingInfo.packedDate | date: 'HH:mm'}}
      </span>
      <span *ngIf="!packingInfo?.packedDate && packedDate" class="margin-left-5">
        {{packedDate | date: "MM/dd/yyyy"}}  {{packedDate | date: 'HH:mm'}}
      </span>
    </div>

  </div>

  <span *ngIf="hasMissingPackages"
        class="br-body-2 padding-left-5 padding-right-5">{{'Service has missing packages' | translate}}</span>

  <div class="layout-column" *ngFor="let package of packageList">
    <div class="layout-column" *ngFor="let packageItem of package.items">

      <div class="padding-5 layout-column">
        <div class="layout-row layout-align-start-center">
          <app-bringoz-package-item [id]="packageItem.size"
                                    [packingDisplayStatus]="packingDisplayStatus"
                                    [isMissingPackage]="packageItem.missing">

          </app-bringoz-package-item>
          <span class="br-body-2 margin-left-5 font-weight-500">X{{packageItem.count}}</span>
        </div>

        <div class="layout-row layout-align-start-center" *ngIf="packageItem.barcode">
          <bringoz-icon iconName="barcode"></bringoz-icon>
          <span class="br-body-2 font-weight-400">{{packageItem.barcode || '---'}}</span>
        </div>

        <div class="layout-row layout-align-start-center" *ngIf="packageItem.weight">
          <bringoz-icon iconName="weight"></bringoz-icon>
          <span class="br-body-2 font-weight-400">{{packageItem.weight | bringozWeight:true:'---'}}</span>
        </div>

        <div class="layout-row layout-align-start-center">
          <bringoz-icon iconName="volume"></bringoz-icon>
          <span class="br-body-2 font-weight-400">{{packageItem.dimensions | bringozDimensions:'---'}}</span>
        </div>

        <div *ngIf="packageItem.requiredSpots" class="layout-row layout-align-start-center">
          <bringoz-icon iconName="spot"></bringoz-icon>
          <span class="br-body-2 font-weight-400">{{packageItem.requiredSpots}}</span>
        </div>

        <div *ngIf="packageItem.pallets" class="layout-row layout-align-start-center">
          <bringoz-icon iconName="pallets"></bringoz-icon>
          <span class="br-body-2 font-weight-400">{{packageItem.pallets}}</span>
        </div>

      </div>

    </div>
  </div>


</div>
